import React, { useEffect } from 'react'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import ScrollListWithTitle from '../../genericComponents/ScrollListWithTitle'
import { loadCompletePoisOnRouteConfiguration } from '../../../store/poiassets/poiassets.actions'
import { selectCompleteGeoentitiesPoisOnRouteConfig } from '../../../store/poiassets/poiassets.selectors'
import { withFrenchSite } from '../../i18n/i18nSite'
import ScrollListWithTitleItem from '../../genericComponents/ScrollListWithTitleItem'
import { TAG_MULTIPATH_CTA } from '../../analytics/analytics.tagids.constants'
import { useDataLoader } from '../../utils/dataLoader'
import { useSelector } from 'react-redux'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { selectCurrentMode, selectIsComputingDone } from '../../../store/itinerary/itinerary.selectors'
import { PUB_TAG } from '../../analytics/PublisherTags.tags'
import s from './PushPoisOnRoute.less'
import { useAction } from '../../utils/react-redux'
import {
  navigateToPoisOnRouteByApp,
  navigateToPoisOnRouteByCategory,
  navigateToPoisOnRouteBySubcategory,
} from '../../../store/history/history.actions'
import { POIS_ON_ROUTE_TYPES } from './poisOnRoute.constants'

const PushPoisOnRoute = () => {
  const poisOnRouteConfig = useDataLoader(
    loadCompletePoisOnRouteConfiguration,
    selectCompleteGeoentitiesPoisOnRouteConfig
  )

  const isComputingDone = useSelector(selectIsComputingDone)
  const currentMode = useSelector(selectCurrentMode)

  const configureAndSendTag = useConfigureAndSendTag()

  const execNavigateToSmrByCategory = useAction(navigateToPoisOnRouteByCategory)
  const execNavigateToSmrBySubcategory = useAction(navigateToPoisOnRouteBySubcategory)
  const execNavigateToSmrByApp = useAction(navigateToPoisOnRouteByApp)

  useEffect(() => {
    if (isComputingDone) {
      configureAndSendTag({
        type: TAG_MULTIPATH_CTA,
        tagInfo: { tag: PUB_TAG.PUB_MULTIPATH_SURMAROUTE },
        isImpression: true,
      })
    }
  }, [isComputingDone, currentMode])

  const navigateToSmrRoute = ({ id, type }) => {
    switch (type) {
      case POIS_ON_ROUTE_TYPES.category:
        return execNavigateToSmrByCategory(id)
      case POIS_ON_ROUTE_TYPES.subcategory:
        return execNavigateToSmrBySubcategory(id)
      case POIS_ON_ROUTE_TYPES.application:
        return execNavigateToSmrByApp(id)
    }
  }

  const onItemClick = (partner) => {
    navigateToSmrRoute(partner)
  }

  if (poisOnRouteConfig instanceof Array && !poisOnRouteConfig.length) {
    return <></>
  }

  return (
    <div className={s.root}>
      <ScrollListWithTitle
        title="Sur ma route"
        data={poisOnRouteConfig}
        render={(partner) => (
          <ScrollListWithTitleItem id={partner.id} {...partner} onClick={() => onItemClick(partner)} />
        )}
      />
    </div>
  )
}

export default withFrenchSite(withEmptyFallbackErrorBoundary(PushPoisOnRoute))
